<template>
  <el-popover placement="bottom-end" width="360" trigger="click" @show="onOpen">
    <div class="notification-list" v-loading="loading">
      <div v-if="!notifications.length" class="notification-empty">
        Нет уведомлений
      </div>
      <div
        v-for="n in notifications"
        :key="n._id"
        class="notification-item"
        @click="goToAccount(n)"
      >
        <i
          :class="
            n.type === 'balance_reconciled'
              ? 'el-icon-success'
              : 'el-icon-warning'
          "
          :style="{
            color: n.type === 'balance_reconciled' ? 'rgb(100,200,28)' : 'red'
          }"
        ></i>
        <div class="notification-item__body">
          <div class="notification-item__text">{{ formatNotification(n) }}</div>
          <div class="notification-item__time">
            {{ $dayjs(n.createdAt).format("DD.MM.YYYY HH:mm") }}
          </div>
        </div>
      </div>
    </div>
    <el-badge
      slot="reference"
      :value="unreadCount"
      :hidden="!unreadCount"
      class="bell-badge"
    >
      <el-button
        icon="el-icon-bell"
        circle
        size="mini"
        type="primary"
      ></el-button>
    </el-badge>
  </el-popover>
</template>
<script>
import {
  getNotifications,
  getUnreadNotificationsCount,
  markAllNotificationsRead
} from "@/api";

const POLL_INTERVAL = 60000;

export default {
  name: "NotificationBell",
  data: () => ({
    unreadCount: 0,
    notifications: [],
    loading: false,
    pollInterval: null
  }),
  methods: {
    async fetchUnreadCount() {
      try {
        const { data } = await getUnreadNotificationsCount();
        if (data.status) this.unreadCount = data.result;
      } catch (error) {
        // Молча пропускаем — это фоновый поллинг, не критично для UI
      }
    },
    async onOpen() {
      this.loading = true;
      try {
        const { data } = await getNotifications({ limit: 20 });
        if (data.status) this.notifications = data.result.docs;
        await markAllNotificationsRead();
        this.unreadCount = 0;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    formatNotification(n) {
      const d = n.data || {};
      if (n.type === "balance_drift_detected") {
        return `Обнаружено расхождение баланса «${d.title}»: расчётный ${d.computedBalance}, в БД ${d.storedBalance} (разница ${d.delta})`;
      }
      if (n.type === "balance_reconciled") {
        return `Баланс «${d.title}» исправлен: с ${d.storedBalanceBefore} на ${d.computedBalance} (разница ${d.delta})`;
      }
      return "Уведомление";
    },
    goToAccount(n) {
      const id = n.balanceAccount && (n.balanceAccount._id || n.balanceAccount);
      if (!id) return;
      this.$router.push({ name: "BalanceFull", params: { id } });
    }
  },
  sockets: {
    // Не += 1 локально: PUSH_CONNECTIONS на бэке может держать больше одного
    // сокета на один и тот же логин (переподключение, не до конца
    // подчищенное старое соединение) — тогда одно и то же событие долетит
    // несколько раз и счётчик уедет от реального. Перезапрашиваем настоящее
    // число с сервера вместо того, чтобы доверять количеству событий.
    notification() {
      this.fetchUnreadCount();
    }
  },
  mounted() {
    this.fetchUnreadCount();
    this.pollInterval = setInterval(this.fetchUnreadCount, POLL_INTERVAL);
  },
  beforeDestroy() {
    clearInterval(this.pollInterval);
  }
};
</script>
<style scoped>
.bell-badge {
  line-height: 1;
}
.notification-list {
  max-height: 400px;
  overflow-y: auto;
  min-height: 40px;
}
.notification-empty {
  color: #909399;
  text-align: center;
  padding: 12px 0;
}
.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 4px;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
}
.notification-item:last-child {
  border-bottom: none;
}
.notification-item:hover {
  background: #f5f7fa;
}
.notification-item i {
  margin-top: 2px;
  flex-shrink: 0;
}
.notification-item__text {
  font-size: 0.85rem;
}
.notification-item__time {
  font-size: 0.7rem;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/NotificationBell.vue